import { guards } from '../typeguards.helpers';

/**
 * Formats a number in plain decimal form, never scientific notation, so an
 * editable numeric override stays human-readable and re-parseable while it is
 * focused (e.g. `2e-8` → `"0.00000008"`).
 *
 * Unlike {@link getDisplayNumber}, magnitude never triggers a switch to
 * scientific notation and no grouping separators are added — the output must
 * round-trip cleanly back through {@link parseNumericInput} on save.
 *
 * @param value - The number to format.
 * @returns Decimal string, or `String(value)` for non-finite input.
 */
export const getDecimalDisplayNumber = (value: number): string => {
  if (!guards.is.finiteNumber(value)) return String(value);
  return value.toLocaleString('en-US', {
    useGrouping: false,
    maximumFractionDigits: 20,
  });
};
